import { apiProxyRequest } from "Api/apiProxyRequest";

import type { Account } from "./types";

export const getAccountRequest = (userId: string) =>
  apiProxyRequest<Account>(`/users/${userId}`);
